import { Module } from 'vuex';
import { LanguageGroup } from '@/types/LanguageGroup';

import {RootState} from "@/store";

export interface LanguageGroupState {
  languageGroup: LanguageGroup | null;
  deleted: boolean;
}

const languageGroupModule: Module<LanguageGroupState, RootState> = {
  namespaced: true,
  state: (): LanguageGroupState => ({
    languageGroup: null,
    deleted: false,
  }),
  mutations: {
    setLanguageGroup(state, payload: any) {
      state.languageGroup = LanguageGroup.fromRaw(payload);
      state.deleted = false;
    },
    setLanguageGroupUpdate(state, payload: any) {
      state.languageGroup = LanguageGroup.fromRaw(payload);
      state.deleted = false;
    },
    setLanguageGroupDelete(state, payload: any) {
      if (state.languageGroup?.idLanguageGroup === payload.idLanguageGroup) {
        state.deleted = true;
      }
    },
    clearLanguageGroup(state) {
      state.languageGroup = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetLanguageGroup({ commit }, payload: any) {
      commit('setLanguageGroup', payload);
    },
    wsSetEmptyLanguageGroup({ commit }) {
      commit('clearLanguageGroup');
    },
    wsLanguageGroupUpdate({ commit }, payload: any) {
      commit('setLanguageGroupUpdate', payload);
    },
    wsLanguageGroupDelete({ commit }, payload: any) {
      commit('setLanguageGroupDelete', payload);
    },
    clearLanguageGroup({ commit }) {
      commit('clearLanguageGroup');
    },
  },
};

export default languageGroupModule;
